export const news = [
  {
    id: 'crn_interview_cylerian',
    title: 'Cylerian Aims To Revolutionize SMB Cybersecurity With AI-Powered Platform',
    summary: 'CRN profiled Cylerian\'s vision and growth strategy, highlighting how the platform integrates security, compliance, and operations for SMBs.',
    published: '2025-02-13T22:12:00Z',
    author: ' CJ Fairfield',
    tags: ['news', 'partners'],
    url: 'https://www.crn.com/news/channel-news/2025/cylerian-poised-to-revolutionize-smb-cybersecurity-with-ai-powered-platform'
  },
    {
    id: 'channelpro_defend_2025_award',
    title: ' Cylerian wins Best Security Solution at ChannelPro Defend 2025',
    summary: 'At the ChannelPro DEFEND: Irvine cybersecurity conference for MSPs, Cylerian was recognized as:🏆 Best Security Solution as voted and published by The ChannelPro Network editorial team covering the event’s award winners. ',
    published: '2025-11-17T00:00:00Z',
    author: 'Anjali Fluker',
    tags: ['news', 'partners'],
    url: 'https://www.channelpronetwork.com/2025/11/17/irvine-cybersecurity-conference-for-msps/'
  },  {
    id: 'sophos_shared_secret_edr_killer',
    title: 'Shared secret: EDR killer in the kill chain',
    summary: 'Sophos researchers found that a new sophisticated “EDR killer” tool is being used by multiple ransomware groups to disable endpoint detection and response protections before the rest of the attack, helping malware run undetected.',
    published: '2025-11-17T00:00:00Z',
    author: 'Gabor Szappanos & Steeve Gaudreault',
    tags: ['news', 'partners'],
    url: 'https://news.sophos.com/en-us/2025/08/06/shared-secret-edr-killer-in-the-kill-chain/'
  }
].sort((a, b) => b.published.localeCompare(a.published));

export const active_news = news.filter(n => new Date(n.published) < new Date());
